<template>
    <div id="square">
        <div class="tab flex ">
            <div class="item"
                 :class="index==tab_active?'active':''"
                 @click="choose_tab(index)"
                 v-for="(item,index) in tab_list"
                 :key="index">{{item}}</div>
        </div>
        <div class="search">
            <el-input placeholder="请输入关键词"
                      class="keywords"
                      prefix-icon="el-icon-search"
                      v-model="keywords"
                      @keyup.enter="search">
            </el-input>
        </div>
        <div class="tags flex ac">
            <span :class="index==tag_active?'active':''"
                  @click="choose_tag(index)"
                  v-for="(item,index) in tag_list"
                  :key="index">{{item.name}}</span>
        </div>
        <div class="tab_con">
            <div class="tab_draw"
                 v-if="water_draw_list.length">
                <waterfall ref="waterfall"
                           :col="col_count"
                           :width="300"
                           :gutterWidth="10"
                           :data="water_draw_list"
                           @loadmore="loadmore_draw"
                           :height="'100%'">
                    <template>
                        <div class="cell_item"
                             v-for="(item, index) in water_draw_list"
                             :key="index">
                            <video muted :src="item.video_url"
                                 class="pic" @mouseenter="videoEnter($event)" @mouseout="videoOut($event)"></video>
                            <div class="more ac" @click="showVideo(item)">
                                <img src="./img/icon_img1.png"
                                     class="icon" />
                                <p>查看详情</p>
                            </div>
                            <div class="el-icon-video-play"></div>
                        </div>
                    </template>
                </waterfall>
            </div>
            <empty v-else></empty>
        </div>
        <el-dialog :visible.sync="videoDialogVisible" @closed="dialogClose" custom-class="is-align-center csd-dialog un-border" width="650px"
        :show-close="false" :close-on-press-escape="false">
            <div class="video_dialog">
                <div class="dialog_close"><i class="el-icon-close" @click="videoDialogVisible=false"></i></div>
                <div class="dialog_title">作品详情</div>
                <div class="video_wrap" flex-center><video ref="dialogVideo" :src="select_video.video_url" controls></video></div>
                <div class="opt_line jb" flex-align>
                    <div class="line_left" flex-align>视频描述<div class="el-icon-document-copy" @click="copy"><span style="margin-left: 2px;">复制</span></div></div>
                    <div class="right_btn">下载</div>
                </div>
                <div class="video_desc">{{ select_video.text_prompt }}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import empty from '@/components/Empty'
export default {
    components: { empty },
    data () {
        return {
            tab_list: ['视频广场'],
            tab_active: 0,
            keywords: '',
            col_count: 5,
            tag_list: [{
                tj_cate_id: '3',
                name: '最近使用'
            }, {
                tj_cate_id: '1',
                name: '热门推荐'
            }, {
                tj_cate_id: '2',
                name: '热门排行'
            }, {
                tj_cate_id: '4',
                name: '最新发布'
            },],
            tag_active: 0,
            water_draw_list: [],
            page: 1,
            water_video_list: [],
            select_video:{},
            videoDialogVisible:false,
            noMore:false,
            loading:false
        }
    },
    created () {
        document.onkeyup = e => {
            if (e.keyCode === 13) {
                // 调用登录 验证方法
                this.search()
            }
        }
        this.get_draw_list(this.tag_list[this.tab_active].tj_cate_id)
        window.addEventListener('resize', this.windowResize);
        this.windowResize()
    },
    methods: {
        //选择标签
        choose_tag (index) {
            this.water_draw_list = []
            this.page = 1
            this.tag_active = index;
            this.noMore = false;
            this.get_draw_list()
        },
        search(){
            console.log("搜索")
            this.water_draw_list = []
            this.page = 1;
            this.noMore = false;
            this.get_draw_list();
        },
        //获取绘画广场数据
        get_draw_list () {
            if(this.loading || this.noMore) return
            this.loading = true;
            this.$http.get(`/front/aivideo/?page_size=20&page=${this.page}`, {params:{keywords:this.keywords}}).then(res => {
                if (res.status == '200') {
                    if (res.data.item_list.length < 20) {
                        this.$message('没有更多了');
                        this.noMore = true;
                    }
                    this.water_draw_list = this.water_draw_list.concat(res.data.item_list);
                } else {
                    this.$message.error(res.data.msg)
                }
            }).finally(()=>{this.loading = false;})
        },
        //绘画广场加载更多
        loadmore_draw () {
            this.page++;
            this.get_draw_list(this.tag_list[this.tab_active].tj_cate_id)
        },
        windowResize () {
            let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (screenWidth < 1042) {
                this.col_count = 2
            } else if (screenWidth < 1352) {
                this.col_count = 3
            } else if (screenWidth < 1980) {
                this.col_count = 4
            } else {
                this.col_count = 5
            }
        },
        videoEnter(e){
            e.target.play()
        },
        videoOut(e){
            e.target.currentTime = 0;
            e.target.pause();
        },
        showVideo(item){
            this.select_video = item;
            this.videoDialogVisible = true;
            this.$nextTick(()=>{
                this.$refs.dialogVideo.play()
            })
        },
        dialogClose(){
            this.select_video = {};
        },
        copy(){
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', this.select_video.text_prompt);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#square {
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
}
.tab {
    justify-content: center;
    margin-bottom: 50px;
    .item {
        cursor: pointer;
        font-size: 22px;
        font-weight: bold;
        color: #949ba4;
        margin: 0 50px;
        position: relative;
        height: 35px;
        line-height: 35px;
        &.active {
            font-size: 26px;
            color: #fff;
            &:after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: 100%;
                height: 5px;
                background: linear-gradient(
                    90deg,
                    #5865f2 0%,
                    rgba(88, 101, 242, 0) 99%
                );
            }
        }
    }
}
.search {
    width: 800px;
    margin: 0 auto;
    .keywords {
        border: 2px solid #5865f2;
        background-color: transparent;
        border-radius: 30px;
        /deep/.el-input__inner {
            background-color: transparent;
            border: none;
            color: rgba(255, 255, 255, 0.78);
        }
    }
}
.tags {
    margin: 20px 0;
    justify-content: center;
    span {
        cursor: pointer;
        font-size: 14px;
        color: #d8d9db;
        padding: 5px 16px;
        margin: 0 5px;
        &.active {
            background: #474e53;
            color: #d8d9db;
            border-radius: 30px;
        }
    }
}
.tab_con {
    overflow: hidden;
    flex-grow: 1;
}
.tab_draw {
    overflow: hidden;
    overflow-y: scroll;
    height: 100%;
    display: flex;
    justify-content: center;
    .vue-waterfall{
        width: auto;
    }
    .cell_item {
        width: 300px;
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        margin-bottom: 10px;

        .pic {
            overflow: hidden;
            border-radius: 10px;
            transition: all 0.4s;
            display: block;
            width: 100%;
        }
        .more {
            display: none;
            opacity: 0;
            cursor: pointer;
            width: 100px;
            height: 36px;
            position: absolute;
            top: calc(50% - 18px);
            left: calc(50% - 50px);
            border: rgba(88, 101, 242, 0.8) solid 2px;
            background-color: rgba(88, 101, 242, 0.533);
            border-radius: 6px;
            justify-content: center;
            .icon {
                width: 16px;
                height: 12px;
                margin-right: 5px;
            }
            p {
                font-size: 14px;
                color: #fff;
            }
            &:hover {
                background-color: rgba(88, 101, 242, 0.8);
            }
        }
        .el-icon-video-play{
            position: absolute;
            left: 10px;
            bottom: 10px;
            background: rgba(0, 0, 0, .2);
            border-radius: 50%;
            font-size: 30px;
            color: #fff;
        }
        &:hover {
            .more {
                display: flex;
                opacity: 1;
                filter: alpha(opacity=100);
            }
        }
    }
}
.tab_video {
    overflow: hidden;
    overflow-y: scroll;
    height: 100%;
    .video_item {
        width: 300px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        .icon {
            width: 30px;
            height: 30px;
            position: absolute;
            left: 15px;
            bottom: 15px;
            z-index: 2;
        }
        &:hover {
            &:before {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.2);
                top: 0;
                left: 0;
                z-index: 1;
            }
        }
    }
}
.video_dialog{
    background-color: #1d1e23;
    width: 650px;
    padding: 15px;
    color: #fff;
    position: relative;
    cursor: pointer;
    .dialog_close{
        position: absolute;
        top: 10px;
        right: 15px;
        color: #707072;
        padding: 5px;
        font-size: 18px;
    }
    .dialog_title{
        font-weight: 700;
        font-size: 15px;
        padding-bottom: 10px;
        border-bottom: 2px solid #343539;
    }
    .video_wrap{
        margin: 15px 0;
        background-color: #111;
        video{
            width: 600px;
            height: 450px;
        }
    }
    .opt_line{
        margin: 15px 0;
        color: #fff;
        .line_left{
            .el-icon-document-copy{
                font-size: 14px;
                margin-left: 15px;
                color: #6c6c6d;
                cursor: pointer;
                &:hover{
                    color: #9DABBD;
                }
            }
        }
        .right_btn{
            cursor: pointer;
            background-color: transparent;
            color: #5865f2;
            border: 1px solid #5865f2;
            border-radius: 1000px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            white-space: nowrap;
            user-select: none;
            width: 60px;
            height: 30px;
            &:hover{
                color: rgba(88, 101, 242, .667);
                border: 1px solid rgba(88, 101, 242, .6666666667);
            }
        }
    }
    .video_desc{
        word-break: break-all;
        white-space: normal;
        line-height: 16px;
        color: #9DABBD;
    }
}
</style>